module.exports = __webpack_public_path__ + "static/media/lessThanComfortable.7f721ade.jpg";